import React from 'react';
import { Link } from 'react-router-dom';
import { Message, Icon, Button } from 'semantic-ui-react';
import { colors, gradients, shadows, radius } from '../../styles/globalStyles';

const NotFound = () => (
  <div style={{
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  }}>
    <Message
      className='animate-fade-in-up'
      style={{
        maxWidth: 500,
        borderRadius: radius.xl,
        padding: '40px 32px',
        boxShadow: shadows.card,
        border: `1px solid ${colors.border}`,
        background: 'rgba(0,0,0,0.03)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        textAlign: 'center',
      }}
    >
      <div style={{
        fontSize: 72,
        fontWeight: 900,
        marginBottom: 8,
        background: gradients.text,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        lineHeight: 1,
      }}>
        404
      </div>
      <Message.Header style={{
        fontSize: 20,
        fontWeight: 700,
        color: colors.textPrimary,
        marginBottom: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
      }}>
        <Icon name='exclamation triangle' style={{ color: colors.warning }} />
        页面不存在
      </Message.Header>
      <p style={{ color: colors.textSecondary, fontSize: 14, margin: '0 0 24px 0' }}>
        请检查你的浏览器地址是否正确
      </p>
      <Button
        as={Link}
        to='/'
        style={{
          background: gradients.primaryButton,
          color: '#fff',
          border: 'none',
          borderRadius: radius.md,
          boxShadow: shadows.glow,
          fontWeight: 600,
        }}
      >
        返回首页
      </Button>
    </Message>
  </div>
);

export default NotFound;
